export { formatMoney, formatHours, initials, addDays, toIsoDay } from "@kipo/shared";

const tz = "Europe/Rome";
export const fmtDate = (d: string | Date | null | undefined, opts: Intl.DateTimeFormatOptions = { day: "numeric", month: "short" }) =>
  d ? new Intl.DateTimeFormat("it-IT", { timeZone: typeof d === "string" && d.length === 10 ? "UTC" : tz, ...opts }).format(typeof d === "string" ? new Date(d.length === 10 ? `${d}T00:00:00Z` : d) : d) : "—";
export const fmtDay = (d: string | Date | null | undefined) => fmtDate(d, { day: "numeric", month: "short", year: "numeric" });
export const fmtTime = (d: string | Date) => new Intl.DateTimeFormat("it-IT", { hour: "2-digit", minute: "2-digit", timeZone: tz }).format(new Date(d));
export const money = (cents: number | bigint | null | undefined) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", useGrouping: "always" as never, maximumFractionDigits: Number(cents ?? 0) % 100 === 0 ? 0 : 2 }).format(Number(cents ?? 0) / 100);
export const hours = (minutes: number | null | undefined) => {
  const h = (minutes ?? 0) / 60;
  return `${Number.isInteger(h) ? h : h.toFixed(1).replace(".", ",")} h`;
};
export const fullName = (u: { firstName: string; lastName?: string | null } | null | undefined) => (u ? `${u.firstName} ${u.lastName ?? ""}`.trim() : "");
export const shortName = (u: { firstName: string; lastName?: string | null } | null | undefined) => (u ? `${u.firstName} ${u.lastName ? u.lastName[0] + "." : ""}`.trim() : "");
export const today = () => new Date().toISOString().slice(0, 10);
export function relativeDays(d: Date | string) {
  const days = Math.floor((Date.now() - new Date(d).getTime()) / 86_400_000);
  if (days <= 0) return "oggi";
  if (days === 1) return "ieri";
  return `${days} gg fa`;
}

/** Intestazione di un giorno rispetto a oggi (YYYY-MM-DD): "Ieri, lunedì 2 novembre", "giovedì 5 novembre", "mercoledì 28 ottobre · 6 giorni fa". */
export function dayHeading(day: string, today: string) {
  const diff = Math.round((Date.parse(day) - Date.parse(today)) / 86_400_000);
  const name = new Intl.DateTimeFormat("it-IT", { weekday: "long", day: "numeric", month: "long", timeZone: "UTC" }).format(new Date(day));
  if (diff === -1) return `Ieri, ${name}`;
  if (diff === 1) return `Domani, ${name}`;
  if (diff < -1) return `${name} · ${-diff} giorni fa`;
  return name;
}
